<template>
    <b-modal
            ref="passwordRecoveryModal"
            :id="id"
            title="Recover Password"
            :ok-only="submitSuccess"
    >
        <template slot="modal-footer">
            <b-button variant="secondary" @click="$refs.passwordRecoveryModal.hide()">
                CANCEL
            </b-button>
            <pb-btn :busy="submitProcessing" variant="primary" v-on:click.native="onSubmit()">
                {{submitSuccess ? 'OK' : 'SEND'}}
            </pb-btn>
        </template>
        <b-container class="text-left">
            <b-row>
                <b-col v-if="submitSuccess">
                    <p>A new password was generated. Please check your Inbox.</p>
                </b-col>
                <b-col v-else>
                    <b-form>
                        <b-row class="my-2" v-if="submitError">
                            <b-col>
                                <b-alert variant="danger" show>{{submitError}}</b-alert>
                            </b-col>
                        </b-row>
                        <b-row class="my-2">
                            <b-col>
                                <b-form-input
                                        id="email"
                                        name="email"
                                        type="text"
                                        placeholder="Email"
                                        v-model.trim="formData.email"
                                        v-validate="'required|email'"
                                        class="secondary"
                                        :state="validateState('email')"
                                ></b-form-input>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-col>
            </b-row>
        </b-container>
    </b-modal>
</template>
<script>

    import LoadingButton from "../../components/LoadingButton";

    function initialData() {
        return {
            submitSuccess: false,
            submitProcessing: false,
            submitError: null,
            formData: {
                email: null,
            }
        }
    }

    import {mapActions} from "vuex";
    import UserApi from "@shared/_api/user";

    export default {
        name: 'password-recovery',
        props: {
            id: String
        },
        data() {
            return initialData();
        },
        methods: {
            ...mapActions("account", ["register"]),
            resetData() {
                this.$validator.reset().finally(() => {
                    Object.assign(this.$data, initialData());
                });
            },
            onSubmit() {
                if (this.submitSuccess) {
                    this.$nextTick(() => {
                        this.$emit('ok');
                        this.$refs.passwordRecoveryModal.hide();
                    })
                } else {
                    this.$validator.validate().then(valid => {
                        if (valid) {
                            this.submitProcessing = true;
                            UserApi.recoverPassword(this.formData).then(() => {
                                this.submitSuccess = true;
                            }).catch(err => {
                                if(err.errorCode === 'EMPTY_USER') {
                                    this.submitError = "User does not exist.";
                                } else {
                                    this.submitError = "An error occured. Please contact our customer support.";
                                }
                            }).finally(() => {
                                this.submitProcessing = false;
                            });
                        }
                    });
                }
            },
            validateState(ref) {

                if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                    return !this.errors.has(ref)
                }
                return null
            },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

</style>
